import { Col } from "react-bootstrap";
import { Box } from "../../../components/box";
import { withStatisticWapper } from "../statistics";
import { ShortDocumentLinkTable } from "./short-document-link-table";
import { FullDocumentLinkTable } from "./full-document-link-table";

export const QuoteStatisticDocumentPage = withStatisticWapper(() => {
  return (
    <>
      <Col sm={12} md={12} className="py-3">
        <Col className="py-3 statistic-header">
          <h3>DANH SÁCH TÀI LIỆU VIỆN DẪN / THAM CHIẾU</h3>
          <p>
            <i>Thống kê các văn bản được tham chiếu trong mỗi tài liệu</i>
          </p>
        </Col>
        {/* Thống kê rút gọn */}
        <Box title="Thống kê rút gọn">
          <ShortDocumentLinkTable />
        </Box>
        {/* Kết thúc thống kê rút gọn */}

        {/* Thống kê chi tiết */}
        <Box title="Thống kê chi tiết">
          <Col className="d-flex statistic_content-grid">
            <FullDocumentLinkTable />
          </Col>
        </Box>
        {/* Kết thúc thống kê chi tiết */}
      </Col>
    </>
  );
});
